let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4g2Mj"), load("5AfWB")]).then(() => parcelRequire('jubPE'));